import React from "react";

import styles from "../../../styles/order-details.module.scss";

import { Button } from "../../components/Button";
import { MapDelivery, MapDeliveryFilled } from "../../components/Icons";

import ROLES from "data/Roles";
import { UserStorage } from "shared/tools/UserStorage";
import { Message } from "../../components/Message";
import Customer from "../Customer";
import OrderItems from "../OrderItems";
import Payers from "../Payers";
import Totals from "../Totals";
import Observation from "../Observation";

const OrderStatus = {
  REJECTED: "REJECTED",
  CANCELED: "CANCELED",
  WAITING_PAYMENT: "WAITING_PAYMENT",
  OPENED: "OPENED",
  IN_PRODUCTION: "IN_PRODUCTION",
  ON_DELIVERY: "ON_DELIVERY",
  FINISHED: "FINISHED",
};

class OrderDetails extends React.Component {
  state = {
    searchingDelivery: false,
    searchDeliveryStatus: 1,
  };

  searchDelivery(status) {
    const setSearchingDelivery = (value) =>
      this.setState({ searchingDelivery: value });
    const setSearchDeliveryStatus = (value) =>
      this.setState({ searchDeliveryStatus: value });

    if (status === "stop") {
      setSearchingDelivery(false);
      setSearchDeliveryStatus(1);
    }

    if (status === "search") {
      setSearchingDelivery(true);
      setSearchDeliveryStatus(2);

      setTimeout(() => {
        setSearchingDelivery(false);
        setSearchDeliveryStatus(3);
      }, 3000);
    }
  }

  getStatusText() {
    const { searchDeliveryStatus } = this.state;

    const texts = {
      1: "Deseja solicitar um entragador?",
      2: "Buscando entregadores na região...",
      3: "Entregador encontrado.",
    };

    return texts[searchDeliveryStatus];
  }

  getMessages = () => {
    const { order } = this.props;

    const orderStatuses = order.statuses.filter(
      (orderStatus) => orderStatus?.value?.reason
    );

    const messages = orderStatuses.map((orderStatus) => {
      const message = {
        type: null,
        title: null,
        text: orderStatus?.value?.reason,
      };

      const warningTitles = {
        // Geral
        MANUAL: "Manual",
        ACCEPT_TIMEOUT: "Não aceito",
        UNKNOWN: "",
        // Cliente
        CUSTOMER_BLOCK: "Cliente bloqueado",

        // Carrinho
        ORDER_CART_LIMIT: "Limite de produtos",
        ORDER_ITEM_LIMIT: "Limite de produtos",
        ORDER_INTERVAL_LIMIT: "Intervalo entre os pedidos",

        // Pagamento
        PAYMENT_REFUSED: "Rejeição ou falha no pagamento",
        PAYMENT_TIMEOUT: "Atraso na confirmação do pagamento",

        // Entrega
        DELIVERY_REFUSED: "Rejeição ou falha na entrega",
        DELIVERY_RETURN: "Em rota de devolução",
      };

      message.title = warningTitles[orderStatus?.value?.code] || "";

      if (
        [OrderStatus.CANCELED, OrderStatus.REJECTED].includes(
          orderStatus.status
        )
      ) {
        message.title = `Pedido ${
          order.status === OrderStatus.CANCELED ? "cancelado" : "rejeitado"
        } - ${message.title}`;
        message.type = "danger";
      } else {
        message.type = "warning";
      }

      return message;
    });

    return messages;
  };

  render() {
    const { order, onCancelOrder } = this.props;
    const { searchingDelivery, searchDeliveryStatus } = this.state;

    let userRole = UserStorage.getLoggedUser()?.role;
    if (!userRole) userRole = ROLES.SHOPKEEPER;

    const canCancel = true;

    const messages = this.getMessages();

    return (
      <div className={styles.orderDetailsContainer}>
        <div className={styles.scrollContainer}>
          {messages.map((message) => (
            <Message
              type={message.type}
              title={message.title}
              text={message.text}
              className="mb-20"
            />
          ))}
          <Customer order={order} />
          <OrderItems order={order} />
          <Observation order={order}/>
          <Payers order={order} />
          <Totals order={order} />

          {false && order.status === OrderStatus.IN_PRODUCTION && (
            <div className={styles.requestDelivery}>
              <div className={styles.map}>
                {searchingDelivery ? <MapDeliveryFilled /> : <MapDelivery />}
                <p>{this.getStatusText()}</p>
              </div>

              {searchDeliveryStatus === 1 && (
                <Button
                  design="default-2"
                  className="w-100"
                  onClick={() => this.searchDelivery("search")}
                >
                  Solicitar entregador
                </Button>
              )}

              {searchDeliveryStatus === 3 && (
                <Button
                  design="default-3"
                  className="w-100"
                  onClick={() => this.searchDelivery("confirm")}
                >
                  Confirmar solicitação
                </Button>
              )}

              {[2, 3].includes(searchDeliveryStatus) && (
                <Button
                  design="default-2"
                  className="w-100"
                  onClick={() => this.searchDelivery("stop")}
                >
                  Cancelar
                </Button>
              )}

              {searchDeliveryStatus === 2 && (
                <div className={styles.progress}>
                  <div className={styles.color} />
                </div>
              )}
            </div>
          )}
          {[OrderStatus.IN_PRODUCTION, OrderStatus.ON_DELIVERY].includes(
            order.status
          ) &&
            canCancel && (
              <div className="d-flex align-center justify-center mt-30">
                <Button design="underline" onClick={() => onCancelOrder(order)}>
                  Cancelar pedido
                </Button>
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default OrderDetails;
